export default {
  alliances: 'Alliances',
  viewProfile: 'Voir le profil',
  services: 'Services',
  title: 'Trouver un pigiste',
  subtitle: 'Un pigiste',
  searchPlaceholder: 'Écrire un Prénom ou une discipline',
  filter: 'Filtrer',
  sort: 'Trier',
  filterBy: 'Filtrer par',
  sortBy: 'Trier par',
  loadMore: 'Charger plus de résultats',
  showResults: 'Voir les résultats',
  alphabetical: 'Classement alphabétique',
  allianceCount: "Classement par nombre d'Alliances",
  rating: 'Évaluation',
  proximity: 'Proximité',
  addService: 'Ajouter un service',
  addCity: 'Ajouter une ville',
  maximum: 'Maximum',
  sorts: {
    az: 'A à Z',
    za: 'Z à A',
    allianceAsc: 'Croissant',
    allianceDesc: 'Décroissant',
    proximity: 'Proximité',
  },
  searchErrorMessage: 'Une erreur est survenue lors de la recherche. Veuillez réessayer.',
  retry: 'Réessayer',
  contactSupport: 'Si le problème persiste, veuillez contacter le support.',
  noResults: 'Aucun pigiste trouvé.',
  refineSearch: "Essayez d'affiner vos critères de recherche pour obtenir de meilleurs résultats.",
  about: 'À propos',
  viewFullProfile: 'Voir le profil complet',
  offeredServices: 'Services offerts',
  businessServices: 'Services offerts',
  businessIndustries: "Secteurs d'activité",
  distance: 'Distance',
  location: 'Localisation',
  noBio: 'Aucune description disponible',
  availability: 'Disponibilité',
} as const;
